// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { logout } from 'client/actions/loginLogout';
import { provision } from 'client/actions/enterprise/user';

import LoggedInPage from './loggedInPage';

const mapStateToProps: Object = (state, ownProps) => {
  const query = _.get(ownProps, 'location.query', {});
  const email = _.get(state, 'user.email');
  const user_id = _.get(state, 'user.oid', null);
  const members = _.get(state, 'members');
  const firstName = _.get(_.find(members, ['type', 'primary']), 'first_name', null);
  const siteConfigs = _.get(state, 'siteConfigs');
  const { code, redirect, id } = query;
  return {
    code,
    email,
    firstName,
    redirect,
    siteConfigs,
    user_id,
    user: state.user,
    id,
  };
};

export default connect(mapStateToProps, { logout, provision })(LoggedInPage);
